export default __webpack_public_path__ + "static/media/05_tag_outdoor-pool-in-summer.8be920d0.svg";